import { render, staticRenderFns } from "./spacings.vue?vue&type=template&id=62dee702"
import script from "./spacings.vue?vue&type=script&lang=js"
export * from "./spacings.vue?vue&type=script&lang=js"
import style0 from "./spacings.vue?vue&type=style&index=0&id=62dee702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports